
import Vue from 'vue'
// import { ResultsData } from '~/types/api/results'

export default Vue.extend({
  props: {
    sm: {
      type: Boolean,
    },
    resultNames: {
      type: Array,
      required: true,
    },
  },
  computed:{
    names() {
      return [...new Set(this.resultNames)];
    }
  }
})
